import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { layoutRoutes } from './layoutRoutes';
import { defaultLayoutPages, blankLayoutPages, notFoundRoute, websiteRoutes } from './menuRoutes';

Vue.use(VueRouter);

// 分配子页面到对应布局路由
layoutRoutes[0].children = [...defaultLayoutPages]; // 默认布局子页面
// layoutRoutes[1].children = [...blankLayoutPages]; // 空白布局子页面
layoutRoutes[2].children = [...websiteRoutes]; // 官网路由子页面



// 最终路由列表
const routes = [

  // 根路径重定向到官网首页（空白布局）
  { path: '/', redirect: '/website/index' },
  
  ...blankLayoutPages,

  // 布局路由（核心）
  ...layoutRoutes,
  // 404 页面（必须放最后）
  notFoundRoute
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// 导航守卫：权限控制 + 页面标题
router.beforeEach((to, from, next) => {
  NProgress.start();

  // 1. 权限控制逻辑
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const requiredRole = to.meta.role || 'user';
    const userToken = localStorage.getItem('token');
    const adminToken = localStorage.getItem('adminToken');
    const hasToken = requiredRole === 'admin' ? adminToken : userToken;

    if (!hasToken) {
      // 跳转对应登录页（空白布局）
      const loginPath = requiredRole === 'admin'
        ? '/memberManagement/memberLogin'
        : '/login';
      next({
        path: loginPath,
        query: { redirect: to.fullPath }
      });
      NProgress.done();
      return;
    }
  }

  // 2. 设置页面标题
  document.title = `专加瓦 - AI专利交底书撰写工具 - ${to.meta.title || '未知页面'}`;

  // 3. 继续导航
  next();
});

// 路由跳转完成
router.afterEach(() => {
  NProgress.done();
});

// 处理重复导航错误
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

export default router;